import gsap from 'gsap';
import Flickity from 'flickity';
import $ from '../core/Dom';
import Viewport from '../core/Viewport';

export default el => {
    let flkty = null;
    const dom = $(el);
    const slides = dom.find('[data-slides]');
    const progressBar = dom.find('[data-progress]').get(0);

    const enable = () => {
        if (!flkty) {
            slides.removeClass('overflow-auto');
            flkty = new Flickity(slides.get(0), {
                contain: true,
                dragThreshold: 10,
                cellAlign: 'left',
                cellSelector: '[data-slide]',
                prevNextButtons: false,
                pageDots: false,
                wrapAround: false,
                freeScroll: true,
                groupCells: true,
                freeScrollFriction: 0.045
            });

            flkty.on('dragStart', () => {
                document.ontouchmove = e => e.preventDefault();
            });

            flkty.on('dragEnd', () => {
                document.ontouchmove = () => true;
            });

            flkty.on('scroll', progress => {
                // console.log(progress);
                const normalized = Math.min(Math.max(0, progress), 1);
                gsap.set(progressBar, { scaleX: normalized });
            });
        } else {
            flkty.resize();
        }
    };

    const disable = () => {
        if (flkty) {
            flkty.destroy();
            flkty = null;
        }
    };

    const onBreakpoint = () => {
        if (Viewport.breakpoint.size >= 750) {
            enable();
        } else {
            disable();
        }
    };

    const init = () => {
        Viewport.on('breakpoint', onBreakpoint);
        onBreakpoint();
    };

    const destroy = () => {
        Viewport.off('breakpoint', onBreakpoint);
        disable();
    };

    return {
        init,
        destroy
    };
};
